import PERFIL from './PERFIL'

export default {
  valores: [
    {
      id: 1,
      descricao: 'Administrativo',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 2,
      pai: 1,
      descricao: 'Usuários',
      path: 'usuario',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 25,
      pai: 2,
      path: 'usuario',
      breadcrumb: ['Administrativo', 'Usuários', 'Consultar usuários'],
      descricao: 'Consultar usuários',
      descricaoNovo: 'Novo usuário',
      oculto: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 3,
      pai: 2,
      path: 'usuario/cadastro',
      breadcrumb: ['Administrativo', 'Usuários', 'Novo usuário'],
      descricao: 'Novo usuário',
      oculto: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 59,
      pai: 2,
      path: 'usuario/nova-senha',
      breadcrumb: ['Administrativo', 'Usuários', 'Trocar senha'],
      descricao: 'Trocar senha',
      oculto: true,
    },
    {
      id: 4,
      descricao: 'Atendimento',
    },
    {
      id: 5,
      pai: 4,
      descricao: 'Pacientes',
      path: 'paciente',
    },
    {
      id: 6,
      pai: 5,
      path: 'paciente',
      oculto: true,
      breadcrumb: ['Atendimento', 'Pacientes', 'Consultar paciente'],
      descricao: 'Consultar paciente',
      descricaoNovo: 'Novo paciente',
    },
    {
      id: 7,
      pai: 5,
      path: 'paciente/cadastro',
      oculto: true,
      breadcrumb: ['Atendimento', 'Pacientes', 'Novo paciente'],
      descricao: 'Novo paciente',
    },
    {
      id: 8,
      pai: 4,
      descricao: 'Profissionais',
      path: 'profissional',
    },
    {
      id: 9,
      pai: 8,
      path: 'profissional',
      oculto: true,
      breadcrumb: ['Atendimento', 'Profissionais', 'Consultar profissional'],
      descricao: 'Consultar profissional',
      descricaoNovo: 'Novo profissional',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 10,
      pai: 8,
      path: 'profissional/cadastro',
      oculto: true,
      breadcrumb: ['Atendimento', 'Profissionais', 'Novo profissional'],
      descricao: 'Novo profissional',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 16,
      pai: 4,
      descricao: 'Bloqueios de profissionais',
      path: 'profissional/bloqueio',
    },
    {
      id: 17,
      pai: 16,
      path: 'profissional/bloqueio',
      breadcrumb: [
        'Atendimento',
        'Profissionais',
        'Bloqueios',
        'Consultar bloqueio',
      ],
      descricao: 'Bloqueios',
      descricaoNovo: 'Novo bloqueio',
      oculto: true,
    },
    {
      id: 18,
      pai: 16,
      path: 'profissional/bloqueio/cadastro',
      breadcrumb: [
        'Atendimento',
        'Profissionais',
        'Bloqueios',
        'Novo bloqueio',
      ],
      oculto: true,
    },
    {
      id: 73,
      pai: 4,
      descricao: 'Pagamento de profissionais',
      path: 'profissional/pagamento/guias',
      perfil: {
        ocultar: [PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 15,
      pai: 4,
      path: 'agenda',
      breadcrumb: ['Atendimento', 'Agenda'],
      descricao: 'Agenda',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 11,
      pai: 4,
      path: 'agendamento',
      breadcrumb: ['Atendimento', 'Agendamento'],
      descricao: 'Agendamento',
    },
    {
      id: 19,
      pai: 4,
      descricao: 'Guia SP/SADT',
      path: 'guia',
    },
    {
      id: 21,
      pai: 19,
      descricao: 'Consultar guia',
      descricaoNovo: 'Nova guia',
      path: 'guia',
      oculto: true,
      breadcrumb: ['Atendimento', 'Guia SP/SADT', 'Consultar guia'],
    },
    {
      id: 20,
      pai: 19,
      descricao: 'Nova guia',
      path: 'guia/cadastro',
      oculto: true,
      breadcrumb: ['Atendimento', 'Guia SP/SADT', 'Nova guia'],
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 12,
      pai: 1,
      path: 'convenio',
      descricao: 'Convênios',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 13,
      pai: 12,
      path: 'convenio',
      breadcrumb: ['Administrativo', 'Convênios', 'Consultar convênio'],
      descricao: 'Consultar convênio',
      descricaoNovo: 'Novo convênio',
      oculto: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 14,
      pai: 12,
      path: 'convenio/cadastro',
      breadcrumb: ['Administrativo', 'Convênios', 'Novo convênio'],
      descricao: 'Novo convênio',
      oculto: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 22,
      pai: 4,
      descricao: 'Médicos',
      path: 'medico',
    },
    {
      id: 24,
      pai: 22,
      path: 'medico',
      oculto: true,
      breadcrumb: ['Atendimento', 'Médicos', 'Consultar médicos'],
      descricao: 'Consultar médicos',
      descricaoNovo: 'Novo médico',
    },
    {
      id: 23,
      pai: 22,
      path: 'medico/cadastro',
      oculto: true,
      breadcrumb: ['Atendimento', 'Médicos', 'Novo médico'],
      descricao: 'Novo médico',
    },
    {
      id: 26,
      descricao: 'Relatórios',
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
    },
    {
      id: 34,
      pai: 26,
      path: 'relatorio/atendimento_plano',
      descricao: 'Atendimentos por plano',
      breadcrumb: ['Relatórios', 'Atendimentos por plano'],
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.SUPERVISAO],
      },
    },
    {
      id: 35,
      pai: 26,
      path: 'relatorio/indicacao_medico',
      descricao: 'Indicações por Médico',
      breadcrumb: ['Relatórios', 'Indicações por Médico'],
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.SUPERVISAO],
      },
    },
    {
      id: 27,
      pai: 26,
      path: 'relatorio/pagamento_profissional',
      descricao: 'Pagamento por profissional',
      breadcrumb: ['Relatórios', 'Pagamento por profissional'],
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
    },
    {
      id: 28,
      pai: 26,
      path: 'relatorio/atendimento_profissional',
      descricao: 'Atendimento por profissional',
      breadcrumb: ['Relatórios', 'Atendimento por profissional'],
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
    },
    {
      id: 57,
      pai: 26,
      path: 'relatorio/levantamento_marketing',
      descricao: 'Levantamento Marketing',
      breadcrumb: ['Relatórios', 'Levantamento Marketing'],
      perfil: {
        permitir: [PERFIL.GERENTE],
        ocultar: [PERFIL.SUPERVISAO],
      },
    },
    {
      id: 58,
      pai: 26,
      path: 'relatorio/agendamentos_desativados',
      descricao: 'Agendamentos Desativados',
      breadcrumb: ['Relatórios', 'Agendamentos Desativados'],
      perfil: {
        permitir: [PERFIL.GERENTE],
        ocultar: [PERFIL.SUPERVISAO],
      },
    },
    {
      id: 32,
      pai: 1,
      descricao: 'Código CID',
      path: 'cid',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 33,
      pai: 32,
      descricao: 'Consultar CIDs',
      breadcrumb: ['Administrativo', 'Código CID', 'Consultar CIDs'],
      path: 'cid',
      ocultar: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 29,
      pai: 1,
      descricao: 'Tabelas de Procedimentos',
      path: 'tabelasProcedimento',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 30,
      pai: 29,
      descricao: 'Consultar tabelas',
      descricaoNovo: 'Nova tabela',
      path: 'tabelasProcedimento',
      oculto: true,
      breadcrumb: [
        'Administrativo',
        'Tabelas de Procedimentos',
        'Consultar tabelas',
      ],
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 31,
      pai: 29,
      descricao: 'Nova tabela',
      path: 'tabelasProcedimento/cadastro',
      oculto: true,
      breadcrumb: ['Administrativo', 'Tabelas de Procedimentos', 'Nova tabela'],
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 36,
      pai: 1,
      descricao: 'Especialidades',
      path: 'especialidade',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 37,
      pai: 36,
      path: 'especialidade',
      breadcrumb: [
        'Administrativo',
        'Especialidades',
        'Consultar especialidades',
      ],
      descricao: 'Consultar especialidades',
      descricaoNovo: 'Nova especialidade',
      oculto: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 38,
      pai: 36,
      path: 'especialidade/cadastro',
      breadcrumb: ['Administrativo', 'Especialidades', 'Nova especialidade'],
      descricao: 'Nova especialidade',
      oculto: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 39,
      pai: 1,
      descricao: 'Bloqueios de usuário',
      path: 'usuario/bloqueio',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 40,
      pai: 39,
      path: 'usuario/bloqueio',
      breadcrumb: [
        'Administrativo',
        'Usuários',
        'Bloqueios',
        'Consultar bloqueio',
      ],
      oculto: true,
      descricao: 'Consultar bloqueio',
      descricaoNovo: 'Novo bloqueio',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 41,
      pai: 39,
      path: 'usuario/bloqueio/cadastro',
      breadcrumb: ['Administrativo', 'Usuários', 'Bloqueios', 'Novo bloqueio'],
      descricao: 'Novo bloqueio',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL, PERFIL.RECEPCIONISTA, PERFIL.FATURISTA],
      },
    },
    {
      id: 42,
      pai: 1,
      descricao: 'Faturamentos',
      perfil: {
        permitir: [PERFIL.GERENTE, PERFIL.FATURISTA],
      },
    },
    {
      id: 43,
      pai: 42,
      path: 'faturamento',
      breadcrumb: ['Administrativo', 'Faturamentos', 'Consultar pacote'],
      descricao: 'Pacotes',
      descricaoNovo: 'Novo pacote',
      perfil: {
        permitir: [PERFIL.GERENTE, PERFIL.FATURISTA],
      },
    },
    {
      id: 44,
      pai: 42,
      path: 'faturamento/cadastro',
      oculto: true,
      breadcrumb: ['Administrativo', 'Faturamentos', 'Novo pacote'],
      descricao: 'Pacote',
      perfil: {
        permitir: [PERFIL.GERENTE, PERFIL.FATURISTA],
      },
    },
    {
      id: 45,
      pai: 42,
      path: 'faturamento/guia',
      breadcrumb: ['Administrativo', 'Faturamentos', 'Faturamento'],
      descricao: 'Faturamento',
      perfil: {
        permitir: [PERFIL.GERENTE, PERFIL.FATURISTA],
      },
    },
    {
      id: 60,
      pai: 42,
      path: 'faturamento/promed/arquivo',
      breadcrumb: ['Administrativo', 'Faturamento', 'Arquivo Promed'],
      descricao: 'Arquivo Promed',
      perfil: {
        permitir: [PERFIL.GERENTE, PERFIL.FATURISTA],
      },
    },
    {
      id: 46,
      pai: 4,
      descricao: 'Evolução',
      perfil: {
        ocultar: [PERFIL.RECEPCIONISTA],
      },
    },
    {
      id: 47,
      pai: 46,
      descricao: 'Questão',
      path: 'evolucao/questao',
      perfil: {
        ocultar: [PERFIL.RECEPCIONISTA],
      },
    },
    {
      id: 48,
      pai: 47,
      path: 'evolucao/questao/cadastro',
      oculto: true,
      breadcrumb: ['Atendimento', 'Evolução', 'Questão', 'Nova questão'],
      descricao: 'Nova questão',
      perfil: {
        ocultar: [PERFIL.RECEPCIONISTA],
      },
    },
    {
      id: 49,
      pai: 47,
      path: 'evolucao/questao',
      oculto: true,
      breadcrumb: ['Atendimento', 'Evolução', 'Questão', 'Consultar questão'],
      descricao: 'Consultar questão',
      descricaoNovo: 'Nova questão',
      perfil: {
        ocultar: [PERFIL.RECEPCIONISTA],
      },
    },
    {
      id: 50,
      pai: 46,
      descricao: 'Formulário',
      path: 'evolucao/formulario',
      perfil: {
        ocultar: [PERFIL.RECEPCIONISTA],
      },
    },
    {
      id: 51,
      pai: 50,
      path: 'evolucao/formulario/cadastro',
      oculto: true,
      breadcrumb: ['Atendimento', 'Evolução', 'Formulário', 'Novo formulário'],
      descricao: 'Novo formulário',
      perfil: {
        ocultar: [PERFIL.RECEPCIONISTA],
      },
    },
    {
      id: 52,
      pai: 50,
      path: 'evolucao/formulario',
      oculto: true,
      breadcrumb: [
        'Atendimento',
        'Evolução',
        'Formulário',
        'Consultar formulário',
      ],
      descricao: 'Consultar formulário',
      descricaoNovo: 'Novo formulário',
      perfil: {
        ocultar: [PERFIL.RECEPCIONISTA],
      },
    },
    {
      id: 61,
      pai: 4,
      descricao: 'Documentos',
      path: 'documento',
    },
    {
      id: 62,
      pai: 61,
      path: 'documento/cadastro',
      oculto: true,
      descricao: 'Cadastro de Documento',
      breadcrumb: ['Atendimento', 'Documentos', 'Novo documento'],
    },
    {
      id: 63,
      pai: 61,
      path: 'documento',
      oculto: true,
      descricao: 'Consulta de Documento',
      descricaoNovo: 'Novo documento',
      breadcrumb: ['Atendimento', 'Documentos', 'Consultar documento'],
    },
    {
      id: 64,
      pai: 26,
      path: 'relatorio/horarios_abertos_vs_marcados',
      descricao: 'Relatório de Horários abertos vs marcados',
      breadcrumb: ['Relatórios', 'Relatório de Horários abertos vs marcados'],
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
    },
    {
      id: 65,
      pai: 1,
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
      descricao: 'Download backup',
      path: 'backup/download',
    },
    {
      id: 66,
      pai: 65,
      path: 'backup/download',
      oculto: true,
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
      breadcrumb: ['Administrativo', 'Backup', 'Download'],
      descricao: 'Download Backup',
    },
    {
      id: 67,
      pai: 46,
      oculto: true,
      breadcrumb: ['Atendimento', 'Evolução', 'Paciente'],
    },
    {
      id: 68,
      pai: 1,
      descricao: 'Domínios',
      path: 'dominio',
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 69,
      pai: 68,
      path: 'dominio',
      breadcrumb: ['Administrativo', 'Domínios', 'Consultar domínios'],
      descricao: 'Consultar domínios',
      descricaoNovo: 'Novo domínio',
      oculto: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 70,
      pai: 68,
      path: 'dominio/cadastro',
      breadcrumb: ['Administrativo', 'Domínios', 'Novo domínio'],
      descricao: 'Novo domínio',
      oculto: true,
      perfil: {
        ocultar: [PERFIL.PROFISSIONAL],
      },
    },
    {
      id: 71,
      pai: 26,
      path: 'relatorio/media_eva_especialidade',
      descricao: 'Média de EVA por especialidade',
      breadcrumb: ['Relatórios', 'Média de EVA por especialidade'],
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
    },
    {
      id: 72,
      pai: 26,
      path: 'relatorio/pagamento_guia',
      descricao: 'Pagamento por guia',
      breadcrumb: ['Relatórios', 'Pagamento por guia'],
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
    },
    {
      id: 74,
      pai: 26,
      path: 'relatorio/pagamento_indicacao_guia',
      descricao: 'Pagamento por indicação de guias',
      breadcrumb: ['Relatórios', 'Pagamento por indicacao de guias'],
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
    },
    {
      id: 75,
      pai: 26,
      path: 'relatorio/guias_nao_faturadas',
      descricao: 'Guias não faturadas',
      breadcrumb: ['Relatórios', 'Guias não faturadas'],
      perfil: {
        ocultar: [
          PERFIL.PROFISSIONAL,
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.SUPERVISAO,
        ],
      },
    },
  ],
}
